import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface HookProps {
  batches: string[];
}

export const useUnarchiveBatches = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ batches }: HookProps) => {
      const result = await apiClient.batchesArchive.unarchiveBatches.mutation({ body: { batches } });
      if (result.status !== 200) throw result.body;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['batches'] });
      toast.success('Successfully unarchived batches!');
    },
    onError: (error) => {
      showErrorToast(error, 'Error unarchiving batches!');
    },
  });
};
